import type { Role, SessionState } from "../types";
import { BluetoothIcon, DeviceIcon, LockIcon, PersonIcon } from "./Icons";

export function PresenceRail({
  state,
  role,
  relayConnected
}: {
  state: SessionState;
  role: Role;
  relayConnected: boolean;
}) {
  const partnerRole = role === "wearer" ? "controller" : "wearer";
  const partnerLabel = role === "wearer" ? "Controller" : "Wearer";

  return (
    <div className="presence-rail">
      <div>
        <PersonIcon />
        <StatusDot on={state.presence[partnerRole]} />
        <span>{partnerLabel} {state.presence[partnerRole] ? "is present" : "is away"}</span>
      </div>
      <div>
        <BluetoothIcon />
        <StatusDot on={state.device.connected} />
        <span>{state.device.connected ? "Little Devil bridge connected" : "Bridge disconnected"}</span>
      </div>
      <div className="presence-rail__chain">
        <Connection label="Private relay" on={relayConnected} Icon={LockIcon} />
        <Connection label="Wearer’s phone" on={state.presence.wearer} Icon={DeviceIcon} />
        <Connection label="Little Devil" on={state.device.connected} Icon={BluetoothIcon} />
      </div>
    </div>
  );
}

function StatusDot({ on }: { on: boolean }) {
  return <span className={`status-dot ${on ? "" : "status-dot--off"}`} />;
}

function Connection({
  label,
  on,
  Icon
}: {
  label: string;
  on: boolean;
  Icon: typeof LockIcon;
}) {
  return (
    <span className="connection">
      <Icon />
      <span>
        {label}
        <small className={on ? "connected-color" : ""}>{on ? "Connected" : "Offline"}</small>
      </span>
    </span>
  );
}
